import React from 'react';

import {
  useAddTeamsToFolder,
  useRemoveTeamsFromFolder,
  useUpdateFolder,
} from 'app/folders/api';
import {
  createFormErrorsContext,
  ShowNonFieldFormErrors,
} from 'app/general/forms';

import {ChangeFolder, DoChangeProps, InitialProps} from './ChangeFolder';

import type {ActionMeta} from 'app/components/general/SweetReactSelect';
import type {FormErrorsProps} from 'app/general/forms';
import type {BasicTeamSerializedType, FolderSerializedType} from 'sweet-types';

interface Props extends FormErrorsProps {
  onClose: () => void;
  item: FolderSerializedType;
  inPopover: boolean;
  parent?: {teams: Array<BasicTeamSerializedType>};
}
export const EditFolder = createFormErrorsContext<Props>(
  ({
    item,
    parent,
    onClose,
    inPopover,
    captureFormErrorsFromRejection,
  }: Props) => {
    const [updateFolder] = useUpdateFolder();
    const [addTeamsToFolders] = useAddTeamsToFolder();
    const [removeTeamFromFolder] = useRemoveTeamsFromFolder();

    const doEditFolder = ({name}: DoChangeProps) => {
      return updateFolder({folder: item, name})
        .unwrap()
        .then(() => onClose(), captureFormErrorsFromRejection);
    };

    const onTeamChange = (
      teams: Array<BasicTeamSerializedType>,
      action: ActionMeta<BasicTeamSerializedType>
    ): Promise<unknown> => {
      if (action.action === 'select-option') {
        return addTeamsToFolders({
          folder: item,
          urls: [action.option.url],
        }).unwrap();
      } else if (action.action === 'remove-value') {
        return removeTeamFromFolder({
          folder: item,
          teamURL: action.removedValue.url,
        }).unwrap();
      }

      return Promise.resolve(true);
    };

    const initial: InitialProps = {
      name: item.name,
      teams: item.teams,
    };

    const allowedTeams: Array<BasicTeamSerializedType> = parent?.teams ?? [];

    return (
      <>
        <ChangeFolder
          allowedTeams={allowedTeams}
          onTeamChange={onTeamChange}
          doChange={doEditFolder}
          onCancel={onClose}
          isSelectOnly={item.parent != null}
          initial={initial}
          inPopover={inPopover}
        />
        <ShowNonFieldFormErrors />
      </>
    );
  }
);
